<template>
  <div class="vars contacts-container">
    <div class="contacts-search-box">
      <div class="icon-search">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path style="fill: #9ca6af" d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z"></path><!----></svg>
      </div>
      <input v-model="searchQuery" type="search" placeholder="Suchen" autocomplete="off" class="contacts-input">
      <div class="add-button" @click="onShowCreateRoom">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path style="fill: #1976d2" d="M17,13H13V17H11V13H7V11H11V7H13V11H17M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"></path><!----></svg>
      </div>
    </div>
    <div class="contacts-list">
      <div class="contact-item" v-for="item in contactsComputed" @click="onUserClicked(item)">
        <div class="contact-item-container">
          <div v-if="item.type === 'group'" class="contact-avatar" style="background-image: url('/group_test.png');"></div>
          <div v-else class="contact-avatar" style="background-image: url('/person_test.png');"></div>
          <div class="contact-name-container">
            <div class="contact-name">{{item.name}}</div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="md" v-model="showCreateRoom" centered title="Neuen Chat starten"
    >
      <b-row class="mt-2">
        <b-col>
          <span>Mitarbeiter auswählen</span>
          <v-jstree ref="js_tree" :allow-transition="false"
                    style="flex: 1 0; border: 1px solid #c0c0c0; border-radius: 0.25rem; margin-top: 0.75rem"
                    class="my-tree" :data="possibleUser"
                    @item-click="onItemClicked"
                    show-checkbox
                    :multiple="true"
                    :allow-batch="true"></v-jstree>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="selectedUser.length > 1">
        <b-col>
          <span>Chatname:</span>
          <b-form-input style="margin-top: 0.75rem" class="form-control text-black"
                        v-model="roomName"
          ></b-form-input>
        </b-col>
      </b-row>
      <template #modal-footer="{ok, cancel}">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="md" variant="primary" @click="onCancelCreateRoom">
          Abbrechen
        </b-button>
        <b-button size="md" :disabled="!canContinue" variant="success" @click="onCreateRoom">
          Chat starten
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {isImageFile, Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";
import VJstree from "vue-jstree";
import {
  decryptAES,
  decryptChatMessages,
  decryptFile,
  decryptRooms,
  encryptAES,
  encryptEntry,
  encryptFile
} from "@/shared/crypto";
import MediaPreview from "@/views/messaging/util/MediaPreview.vue";
export default {
  name: "contacts",
  components: {
    VJstree,
  },
  data() {
    return {
      // util
      searchQuery: "",
      loader: undefined,
      // create room
      showCreateRoom: false,
      possibleUser: [],
      selectedUser: [],
      selectedUserNames: [],
      roomName: "",
      currentNewId: '',
      contacts: [],
    }
  },
  computed: {
    canContinue() {
      if (this.selectedUser.length === 1) {
        return true;
      } else if (this.selectedUser.length > 1 && this.roomName !== "") {
        return true;
      } else {
        return false;
      }
    },
    contactsComputed() {
      let res = this.contacts;
      if (this.searchQuery !== "") {
        res = this.contacts.filter((contact) => {
          return contact.name.toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      }
      res.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
      return res;
    }
  },
  mounted() {
    this.showLoader()
    this.$http.get(
        Server_URL + '/auftragsbuch/messaging/contacts'
    ).then(this.handleDataInit, this.responseError)
  },
  methods: {
    onUserClicked(item) {
      if (item.type === "group") {
        Android.onSelectRoom(item.id);
      } else {
        this.roomName = "";
        this.selectedUser = [];
        this.selectedUserNames = [];
        this.selectedUser.push(item.id);
        this.selectedUserNames.push(item.name);
        this.onCreateRoom();
      }
    },
    onItemClicked(node, item, e) {
      this.selectedUser = this.getSelectedUsers(this.possibleUser);
      this.selectedUserNames = this.getSelectedNames(this.possibleUser);
    },
    handleDataInit(response) {
      if (response.status === 200) {
        let data = response.body;
        this.possibleUser = this.setNames(data.users);
        if (response.body.rooms) {
          for (let i = 0; i < response.body.rooms.length; i++) {
            this.contacts.push({
              id: response.body.rooms[i].id,
              type: "group",
              name: response.body.rooms[i].name,
            })
          }
        }
        this.hideLoader();
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    setNames(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user') {
          let res = JSON.parse(sessionStorage.getItem(cur.id));
          if (res !== null) {
            org[i].text = res.first_name + " " + res.surname;
            this.contacts.push({
              id: cur.id,
              type: "user",
              name: org[i].text,
            })
          }
        }
        if (cur.children !== null && cur.children.length > 0) {
          org[i].children = this.setNames(cur.children);
        }
      }
      return org
    },
    getSelectedUsers(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.id)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedUsers(cur.children))
        }
      }
      return res;
    },
    getSelectedNames(org) {
      let res = [];
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          res.push(cur.text)
        }
        if (cur.children !== null && cur.children.length > 0) {
          res = res.concat(this.getSelectedNames(cur.children))
        }
      }
      return res;
    },
    unselectUsers(org) {
      for (let i = 0; i < org.length; i++) {
        let cur = org[i];
        if (cur.node_type === 'user' && cur.selected === true) {
          org[i].selected = false;
        }
        if (cur.children !== null && cur.children.length > 0) {
          this.unselectUsers(cur.children)
        }
      }
    },
    onCreateRoom() {
      this.selectedUser.push(this.$cookies.get("ps_user_id"));
      let res = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      this.selectedUserNames.push(res.full_name);
      encryptAES(sessionStorage.getItem("aes"), res.full_name + " hat die Gruppe erstellt.").then(enc => {
        let req = {
          room_name: this.roomName,
          participants: this.selectedUser,
          participant_names: this.selectedUserNames,
          initial_message: enc,
        };
        this.showLoader()
        this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room', req
        ).then(this.handleRoomOk, this.responseError)
        this.showCreateRoom = false;
      })
    },
    handleRoomOk(response) {
      if (response.status === 200) {
        let room = response.body;
        if (room.latest_message_id === 0) {
          room.lastMessage = null;
        }
        this.hideLoader();
        Android.onSelectRoom(room.roomId);
      } else {
        this.hideLoader();
        window.location = Redirect_500;
      }
    },
    onShowCreateRoom() {
      this.unselectUsers(this.possibleUser);
      this.selectedUser = [];
      this.selectedUserNames = [];
      this.roomName = "";
      this.showCreateRoom = true;
    },
    onCancelCreateRoom() {
      this.showCreateRoom = false;
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  }
}
</script>

<style>
form-control:disabled, .form-control[disabled] {
  color: black !important;
}

.text-black {
  color: black;
}

.tree-default .tree-disabled > .tree-checkbox {
  display: none;
}

.tree-default .tree-disabled {
  color: inherit !important;
}

</style>

<style scoped>
.my-tree {
  max-height: calc(30vh - 70px);
  overflow: auto;
}
.vars {
  --chat-container-border-radius: 4px;
  --chat-sidemenu-bg-color: #fff;
  --chat-border-style: 1px solid #e1e4e8;
  --chat-color: #0a0a0a;
  --chat-bg-color-input: #fff;
  --chat-color-caret: #1976d2;
  --chat-sidemenu-border-color-search: #e1e5e8;
  --chat-room-color-username: #0a0a0a;

}

.contacts-container {
  -webkit-text-size-adjust: 100%;
  font-size: .875rem;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  -webkit-font-smoothing: antialiased;
  color: var(--chat-color);
  overflow-wrap: break-word;
  white-space: normal;
  -webkit-tap-highlight-color: transparent;
  border-right: var(--chat-border-style);
  font-family: inherit;
  display: flex;
  flex-flow: column;
  flex: 0 0 25%;
  min-width: 260px;
  max-width: 500px;
  position: relative;
  background: var(--chat-sidemenu-bg-color);
  height: 100%;
  border-top-left-radius: var(--chat-container-border-radius);
  border-bottom-left-radius: var(--chat-container-border-radius);

}
.contacts-search-box {
  font-family: inherit;
  position: sticky;
  display: flex;
  align-items: center;
  height: 64px;
  padding: 0 15px;
}
 .icon-search {
   display: flex;
   position: absolute;
   left: 30px;
 }

 .contacts-input {
   -webkit-font-smoothing: antialiased;
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   font-family: inherit;
   height: 38px;
   width: 100%;
   background: var(--chat-bg-color-input);
   color: var(--chat-color);
   font-size: 15px;
   outline: 0;
   caret-color: var(--chat-color-caret);
   padding: 10px 10px 10px 40px;
   border: 1px solid var(--chat-sidemenu-border-color-search);
   border-radius: 20px;
   min-width: 10px;
   -webkit-appearance: none;
 }
 .add-button {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   max-height: 30px;
   display: flex;
   cursor: pointer;
   transition: all .2s;
   font-family: inherit;
   margin-left: auto;
   padding-left: 10px;
 }
 .contacts-list {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   font-family: inherit;
   flex: 1;
   position: relative;
   max-width: 100%;
   cursor: pointer;
   padding: 0 10px 5px;
   overflow-y: auto;
 }
 .contact-item {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   cursor: pointer;
   font-family: inherit;
   border-radius: 8px;
   align-items: center;
   display: flex;
   flex: 1 1 100%;
   margin-bottom: 5px;
   padding: 0 14px;
   position: relative;
   min-height: 71px;
   transition: background-color .3s cubic-bezier(.25,.8,.5,1);
 }

 .contact-item-container {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   cursor: pointer;
   font-family: inherit;
   display: flex;
   flex: 1;
   align-items: center;
   width: 100%;
 }
 .contact-avatar {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   white-space: normal;
   -webkit-tap-highlight-color: transparent;
   cursor: pointer;
   background-size: cover;
   background-position: center center;
   background-repeat: no-repeat;
   background-color: #ddd;
   height: 42px;
   width: 42px;
   min-height: 42px;
   min-width: 42px;
   margin-right: 15px;
   border-radius: 50%;
   font-family: inherit;
 }
 .contact-name-container {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   font-weight: 400;
   line-height: 1.5;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   color: var(--chat-color);
   overflow-wrap: break-word;
   -webkit-tap-highlight-color: transparent;
   cursor: pointer;
   width: 100%;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   font-family: inherit;
   flex: 1;
 }

 .contact-name {
   -webkit-text-size-adjust: 100%;
   font-size: .875rem;
   text-align: left;
   -webkit-font-smoothing: antialiased;
   cursor: pointer;
   line-height: 25px;
   width: 100%;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
   font-family: inherit;
   flex: 1;
   color: var(--chat-room-color-username);
   font-weight: 500;
 }
</style>
